import { formatMetricByFormatter } from '~/modules/analytics';
import { useConvertMoneyByCurrency } from '~/modules/shopify';
import { IMetricFormatter } from '~/modules/analytics/types';
import { useCallback } from 'react';

// ─── Metric formatter config ──────────────────────────────────────────────────
// Maps each scroll metric key to its IMetricFormatter.
// Change a formatter here and it applies everywhere automatically.

export const SCROLL_METRIC_FORMATTER = {
  avgDwellTimeMs: IMetricFormatter.DURATION_MS,
  dwellTimeMs: IMetricFormatter.DURATION_MS,
  revenue: IMetricFormatter.CURRENCY,
  visitors: IMetricFormatter.NUMBER_COMMAS_LEAN,
  orders: IMetricFormatter.NUMBER_COMMAS,
  conversionRate: IMetricFormatter.PERCENTAGE_STRING,
  convertedSessions: IMetricFormatter.NUMBER_COMMAS_LEAN,
  convertedVisitors: IMetricFormatter.NUMBER_COMMAS_LEAN,
  percUsers: IMetricFormatter.PERCENTAGE_STRING,
  percDropOff: IMetricFormatter.PERCENTAGE_STRING,
  percSessionConverted: IMetricFormatter.PERCENTAGE_STRING,
  percVisitorsConverted: IMetricFormatter.PERCENTAGE_STRING,
  percDwellTimeMs: IMetricFormatter.PERCENTAGE_STRING,
} as const satisfies Partial<Record<string, IMetricFormatter>>;

export const useScrollMetricFormatters = () => {
  const { getTextPrice } = useConvertMoneyByCurrency();

  const formatMetric = useCallback(
    (key: keyof typeof SCROLL_METRIC_FORMATTER, data: number) => {
      let value = data;

      //TODO: check if this is correct
      if (SCROLL_METRIC_FORMATTER[key] === IMetricFormatter.PERCENTAGE_STRING) {
        value = data / 100;
      }

      return formatMetricByFormatter({
        value,
        formatter: SCROLL_METRIC_FORMATTER[key],
        getTextPrice,
      });
    },
    [getTextPrice],
  );

  return { formatMetric };
};
